import {
  kodplaner_ekkodplaner_koddelar,
  kodplaner_ekkodplaner_koddelar_kodbegrepp,
} from '../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';

export const kodbegreppByPosNr = (
  fromPosition: number,
  toPosition: number,
  koddel: kodplaner_ekkodplaner_koddelar
): kodplaner_ekkodplaner_koddelar_kodbegrepp | undefined => {
  const kodbegreppList = koddel.kodbegrepp;

  if (kodbegreppList == null) {
    return undefined;
  }

  for (let i = 0; i < kodbegreppList.length; i++) {
    const kodbegrepp = kodbegreppList[i];

    if (
      kodbegrepp != null &&
      kodbegrepp.fran_pos === fromPosition &&
      kodbegrepp.till_pos === toPosition
    ) {
      return kodbegrepp;
    }
  }

  return undefined;
};
